<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> BlockList E-mail</h3>
      </div>
    </div>
    <BlockListListEmail
      ref="BlockListList"
      v-on:New="onNew"
      v-on:Edit="onEdit"
    />
  </div>
</template>

<script>
import BlockListListEmail from './components/list/BlockListListEmail.vue'

export default {
  name: 'BlockListEmail',
  components: { BlockListListEmail },
  data () {
    return {
      showAdd: false
    }
  },
  methods: {
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.BlockListAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blocklist/BlockList/blockListEmail.vue